import { render, staticRenderFns } from "./Cinema.vue?vue&type=template&id=771a75e0&"
import script from "./Cinema.vue?vue&type=script&lang=ts&"
export * from "./Cinema.vue?vue&type=script&lang=ts&"
import style0 from "./Cinema.vue?vue&type=style&index=0&id=771a75e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports